export default __webpack_public_path__ + "static/media/5.26b2d9f7.png";